export default __webpack_public_path__ + "static/media/newprofsmll.34f3f1d8.jpeg";